import { useMemo } from 'react';
import { EngagementSpotlight } from '@atlassiansox/engagekit-ts/ui/Spotlight';
import EngagementInlineDialog from '@atlassiansox/engagekit-ts/ui/InlineDialog';
import { useCoordination } from '@atlassiansox/engagekit-ts/controllers/use-coordination';
import Coordination from '@atlassiansox/engagekit-ts/controllers/coordination/main';

import type {
	EngagementPlatformPluginConfig,
	EngagementPlatformPluginOptions,
} from '@atlaskit/editor-plugin-engagement-platform/engagementPlatformPluginType';

import { useCoordinationClient } from '@confluence/engagement-provider';

export const useEditorEngagementPlatform = (): {
	config: EngagementPlatformPluginOptions;
} => {
	const coordinationClient = useCoordinationClient();

	// [ED-27497] IMPORTANT: If you change the code below, please also update the
	// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/engagementPlatformPluginOptions.ts
	return useMemo(() => {
		const config: EngagementPlatformPluginConfig = {
			epComponents: {
				EngagementSpotlight,
				EngagementInlineDialog,
				Coordination,
			},
			epHooks: {
				useCoordination,
			},
			coordinationClient,
		};

		return {
			config,
		};
	}, [coordinationClient]);
};
